import { Menu, Title, useCRTNavigation } from "@mike/crt";
import { Page } from "../components/Page";

const menuItems = [
  {
    label: "PROJECTS",
    path: "/projects",
  },
  {
    label: "ABOUT",
    path: "/about",
  },
  {
    label: "RESUME",
    external: "/files/MichaelCavallaroResume.pdf",
  },
  {
    label: "CONTACT",
    path: "/contact",
  },
];

export function HomePage() {
  const { navigate } = useCRTNavigation();

  const items = menuItems.map((item) => ({
    label: item.label,
    action: () => {
      if (item.external) {
        window.open(item.external, "_blank");
      } else if (item.path) {
        navigate(item.path);
      }
    },
  }));

  return (
    <Page>
      <Title name="MIKE" subtitle="CAVALLARO" version={__APP_VERSION__} />
      <Menu items={items} />
    </Page>
  );
}
